export default __webpack_public_path__ + "static/media/Orbitron-SemiBold.f21825bb.ttf";